import { BEIGE_300, BLUE_600, DEEP_SPACE_BLACK, GRAY_900, InterVariableFontFamily, NO_RED, RhetorikFontFamily, WHITE, YES_GREEN } from './theme'
import { ThemeOptions, createTheme } from '@mui/material'

export const BKBNTheme: ThemeOptions = ({
  palette: {
    mode: 'light',
    primary: {
      main: DEEP_SPACE_BLACK,
    },
    secondary: {
      main: BLUE_600,
      contrastText: WHITE,
    },
    error: {
      main: NO_RED,
    },
    success: {
      main: YES_GREEN,
    },
    divider: 'rgba(160,160,160,0.12)',
    background: {
      default: BEIGE_300,
      paper: WHITE,
    },
    // custom
    hint: {
      main: 'rgba(34, 41, 46, 0.5)' // custom for input hint (remove when reworking inputs??)
    }
  },
  shape: {
    borderRadius: 8,
  },
  spacing: (factor: number) => `${factor}rem`,
  typography: {
    fontFamily: InterVariableFontFamily,
    fontWeightBold: 550,
    fontWeightSemiBold: 450,
    fontWeightMedium: 450,
    fontWeightRegular: 350,
    h1: {
      fontSize: '7.2rem',
      fontWeight: 550,
      lineHeight: '8.6rem'
    },
    h2: {
      fontSize: '6rem',
      fontWeight: 550,
      lineHeight: '7.2rem'
    },
    h3: {
      fontSize: '4.8rem',
      fontWeight: 550,
      lineHeight: '5.7rem'
    },
    h4: {
      fontSize: '3.6rem',
      fontWeight: 550,
      lineHeight: '4.3rem'
    },
    h5: {
      fontSize: '3rem',
      fontWeight: 550,
      lineHeight: '3.6rem'
    },
    h6: {
      fontSize: '2.4rem',
      fontWeight: 550,
      lineHeight: '3rem',
    },
    body1: { // TODO: Remove implementations later, use text-sm instead
      fontSize: '1.4rem',
      lineHeight: 1.3,
    },
    'text-2xl': {
      fontSize: '2.4rem',
      lineHeight: 1.3,
    },
    'text-xl': {
      fontSize: '2rem',
      lineHeight: 1.3,
    },
    'text-lg': {
      fontSize: '1.8rem',
      lineHeight: 1.3,
    },
    'text-md': {
      fontSize: '1.6rem',
      lineHeight: 1.3,
    },
    'text-sm': {
      fontSize: '1.4rem',
      lineHeight: 1.3,
    },
    'text-xs': {
      fontSize: '1.2rem',
      lineHeight: 1.3,
    },
    'display-xl': {
      fontWeight: 300,
      lineHeight: 1.1,
      color: GRAY_900,
      fontSize: '6rem',
      fontFamily: RhetorikFontFamily,
    },
    'display-lg': {
      fontWeight: 300,
      lineHeight: 1.1,
      color: GRAY_900,
      fontSize: '4.8rem',
      fontFamily: RhetorikFontFamily,
    },
    'display-md': {
      fontWeight: 300,
      lineHeight: 1.1,
      color: GRAY_900,
      fontSize: '3.6rem',
      fontFamily: RhetorikFontFamily,
    },
    'display-sm': {
      fontWeight: 300,
      lineHeight: 1.1,
      color: GRAY_900,
      fontSize: '2.8rem',
      fontFamily: RhetorikFontFamily,
    },
    'display-xs': {
      fontWeight: 300,
      lineHeight: 1.1,
      color: GRAY_900,
      fontSize: '2.4rem',
      fontFamily: RhetorikFontFamily,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
})

export const CreateBKBNTheme = createTheme(BKBNTheme)
